import { render } from "./InternalPercentage.vue?vue&type=template&id=49cf50bc"
import script from "./InternalPercentage.vue?vue&type=script&lang=ts"
export * from "./InternalPercentage.vue?vue&type=script&lang=ts"
script.render = render

export default script